'use client'

import { useTranslations } from 'next-intl'

import { contentDesignFormConfig } from '@/content-from-sections/client'

import { ContentForm } from '../../../ContentForm'
import {
	aboutFormConfig,
	qrNameFormConfig,
	socialLinksFormConfig,
	TQrContentFormSection,
	welcomeScreenFormConfig,
} from '../../../contentFormSections'
import { QR_TYPE, TContentFormProps } from '../../../generatorTypes'

export const VCardContentForm = (props: TContentFormProps) => {
	const t = useTranslations()

	const config = {
		formSectionList: [
			contentDesignFormConfig(t),
			aboutFormConfig(t),
			socialLinksFormConfig(t),
			welcomeScreenFormConfig(t),
			qrNameFormConfig(t),
		] satisfies TQrContentFormSection[],
	}

	return <ContentForm qrType={QR_TYPE.VCard} config={config} {...props} />
}
